import { Product_Group_Key } from '@occc/graphql';

export const productGroupKeysMap = {
  [Product_Group_Key.Upc]: 'UPC',
  [Product_Group_Key.Sku]: 'SKU',
  [Product_Group_Key.Group]: 'Line Item Group',
  [Product_Group_Key.FuelGradeId]: 'Fuel Grade Id',
};

export const TAR_SWITCH_FIELD_NAME = 'userSelectable';
export const PRODUCT_GROUP_FIELD_NAME = 'key';
